import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { COLLECTIONS, OFFERS_DOC, type OfferPdf, type OffersConfig } from '@mitang/shared';
import { db } from '../lib/firebase';

/**
 * Shareable PDFs, managed on the admin panel's PDFs page — any number of them,
 * each with its own button title, shown on every category. Legacy
 * warranty/cashback fields are converted on the fly so older setups keep
 * working without a migration.
 */
export function useOfferPdfs(): OfferPdf[] {
  const [config, setConfig] = useState<OffersConfig | null>(null);
  useEffect(() => {
    const ref = doc(db, COLLECTIONS.appConfig, OFFERS_DOC);
    return onSnapshot(
      ref,
      (snap) => setConfig((snap.data() as OffersConfig | undefined) ?? null),
      () => setConfig(null),
    );
  }, []);
  if (!config) return [];
  if (config.items?.length) {
    return config.items.slice().sort((a, b) => a.order - b.order);
  }
  const legacy: OfferPdf[] = [];
  if (config.warranty) {
    legacy.push({ id: 'warranty', title: 'Warranty Offer', url: config.warranty, order: 0, updatedAt: 0 });
  }
  if (config.cashback) {
    legacy.push({ id: 'cashback', title: 'Cash Back Offer', url: config.cashback, order: 1, updatedAt: 0 });
  }
  return legacy;
}
